import React, { type HTMLAttributes } from "react";
import { useNationalDogSurveyContext } from "../../NationalDogSurvey/NationalDogSurvey.context";
import { Button } from "../common";
import { Chevron } from "../common/Icons";
import CheckCircle from "../common/Icons/CheckCircle";
import * as styles from "./NDSSurveyNavigation.module.scss";

export interface NDSSurveyNavigationProps extends HTMLAttributes<HTMLElement> {
	onSubmit?: () => void;
	onNext?: () => void;
	onPrevious?: () => void;
	onNextTitle?: string;
	onPreviousTitle?: string;
	onNextDisabled?: boolean;
	isCentered?: boolean;
	isConfirmMode?: boolean; 
	onConfirmAll?: () => void; 
}

export const NDSSurveyNavigation: React.FC<NDSSurveyNavigationProps> = ({
	onSubmit,
	onNext,
	onPrevious,
	onNextDisabled,
	onPreviousTitle = "Back",
	onNextTitle = "Next",
	isCentered = false,
}) => {
	const { screenState, isConfirmMode, setIsConfirmMode } =
		useNationalDogSurveyContext();
	return (
		<div className={styles.navWrapper}>
			{onSubmit && <span className={styles.endSurvey}>End Survey?</span>}
			<nav
				className={
					!isCentered
						? styles.navigationContainer
						: styles.navigationContainerCentered
				}
			>
				<div className={styles.buttonContainer}>
					{onPrevious && !onSubmit && (
						<Button
							onClick={onPrevious}
							customDataLayerObject={{
								question_id: screenState.screen,
							}}
							variant="tertiary"
							fullWidth={true}
							IconLeft={() => <Chevron height="18px" rotation={-90} />}
						>
							{onPreviousTitle}
						</Button>
					)}
					{isConfirmMode === "editing" ? (
						<Button
							className={styles.nextButton}
							type={"button"}
							onClick={() => setIsConfirmMode("clear")}
							customDataLayerObject={{
								question_id: screenState.screen,
							}}
							fullWidth={true}
							variant="secondary"
							IconRight={() => <CheckCircle height="22px" />}
						>
							Confirm edit
						</Button>
					) : (
						<Button
							className={styles.nextButton}
							type={"button"}
							onClick={onSubmit || onNext}
							customDataLayerObject={{
								question_id: screenState.screen,
							}}
							fullWidth={true}
							variant="secondary"
							disabled={onNextDisabled}
						>
							{onNextTitle}
						</Button>
					)}
				</div>
			</nav>
		</div>
	);
};

export default NDSSurveyNavigation;
